const pad = (num: any, size: number) => {
  if (num === null || num === undefined) {
    return "0".repeat(size);
  }
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
};

export default pad;
